import styled from 'styled-components';

export const DivExames = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 10px;
`;

export const Div = styled.div`
  margin-bottom: 30px;
`;
